export const mapRecommendationStatus = {
  buy: { label: 'Compra', bg: 'alert.success', color: 'content.alwaysLight' },
  sell: { label: 'Venda', bg: 'alert.error', color: 'content.alwaysLight' },
  keep: {
    label: 'Manter',
    bg: 'alert.informationLight',
    color: 'content.alwaysDark',
  },
  neutral: {
    label: 'Neutro',
    bg: 'alert.informationLight',
    color: 'content.alwaysDark',
  },
};

type ReverseRecommendationStatus = {
  [key: string]: keyof typeof mapRecommendationStatus;
};

export const mapReverseRecommendationStatus: ReverseRecommendationStatus = {
  venda: 'sell',
  compra: 'buy',
  manter: 'keep',
  neutro: 'neutral',
};
